import React from 'react';
import {Head} from 'react-static';
const {SITE_URL} = process.env;

export default function PageMeta({
  url = `${SITE_URL}`,
  ogImage = 'https://cdn.foodrevolution.org/ff/og/ff-evergreen-opengraph-landingpage-1200x1200-v20220719.png',
  title = 'Fantastic Fungi | Watch the special event edition – free!',
  description = 'Catch the award-winning Fantastic Fungi special event edition — FREE screening for 4 days. This MUST-SEE documentary has rocked audiences since it came out, with 100% ratings on Rotten Tomatoes and rave reviews from film critics.'
}) {
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:site" content="@afoodrevolution" />
      <meta property="twitter:image" content={ogImage} />
      <meta property="fb:app_id" content="1685199371775570" />
      <meta property="og:site_name" content="Fantastic Fungi" />
      <meta property="og:title" content={title} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
    </Head>
  );
}
